export default "__VITE_ASSET__CXOpoZW3__"